import React from 'react';
import {useUserProfileQuery} from "apis/authenticationApi";
import LogoutButton from "./LogoutButton";
import MessagesIcon from './MessagesIcon';

const CurrentUserInfo = () => {
    const {data: userProfile} = useUserProfileQuery();
    

    if(userProfile) {
        return (<div className="current-user-info">
                <span className="first-name">{userProfile.firstName}</span>
                <span className="last-name">{userProfile.lastName}</span>
                {userProfile?.company?.id && <MessagesIcon/>}
                
            <LogoutButton />
        </div>);
    }
    else
    {
        return (<></>);
    }
}

export default CurrentUserInfo;